var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.438 22.149l-6.01 6.717a2 2 0 01-2.828-2.828l6.717-6.01-1.06-1.061m0 0l4.242 4.242.707-.707-4.242-4.242-.708.707zM25.913 20.38l-2.828-2.828c-.354-1.06 1.06-3.181 3.182-2.474 2.121.707 3.182-1.061 3.182-1.061s2.475 5.303-3.536 6.364z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgDesign;